module.exports = __webpack_public_path__ + "img/section-5-m.3be2aa7.webp";